import React from 'react';

import ArrowDropDownRoundedIcon from '@material-ui/icons/ArrowDropDownRounded';
import useOrganisationSettings from 'components/hooks/useOrganisationSettings';
import ObjectiveTreeView, { ObjectiveDisplay } from 'screens/home/tasksList/ObjectiveTreeView';
import styled from 'styled-components';
import { StyledTypography } from 'styles/common';

import { StyledIcon } from 'constants/icons';

// TODO: refactor, passing updateTask like this is bad and unnecessary
// updateTask should be inside a separate file which is not tightly coupled like it is currently
// and it can be used easily
export default function ObjectiveField({ taskDetails, updateTask }) {
  const { moduleName, objectivesName, keyResultsName } = useOrganisationSettings();

  return (
    <ObjectiveTreeView
      renderObjectiveDisplay={({ isOpen }) => (
        <StyledObjectiveDisplay
          color="default"
          variant={isOpen ? 'contained' : 'outlined'}
          endIcon={
            <StyledIcon color="textSecondary">
              <ArrowDropDownRoundedIcon />
            </StyledIcon>
          }
        >
          <StyledTypography variant="body2" color="textSecondary">
            {taskDetails.subObjective?.name || objectivesName}
          </StyledTypography>
        </StyledObjectiveDisplay>
      )}
      selectedObjective={taskDetails.subObjective}
      objectiveColor="textSecondary"
      objectiveIconColor="textPrimary"
      onObjectiveChange={(tag) => {
        console.log('DetailSection -> tag', tag);
        updateTask({ ...taskDetails, subObjective: tag });
      }}
    />
  );
}

const StyledObjectiveDisplay = styled(ObjectiveDisplay)`
  padding: 0.25rem 1rem 0.25rem 1rem;
  border-width: 1px;
  // border-color: transparent;
  // &:hover,
  // &:active {
  //   border-width: 1px;
  //   border-color: #eee;
  // }
  background-color: transparent;
  margin-left: -0.5rem;
  ${(props) => props.theme.breakpoints.down('xs')} {
    margin-left: 10px;
    max-width: 185px;
    padding-bottom: 5px;
  }
`;
